<template>
    <b-navbar toggleable="xl" class="shadow pb-0">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <b-navbar-brand @click="inicio()">
        <img alt="Vue logo" src="../../../assets/dentalia_logo.png" class="dentaliaLogo"/>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse"  is-nav >
        <b-navbar-nav>
          <template v-for="(menu) in menuArray">
              <menu2 :id-menu-padre="menuSeleccionado.idMenu" :key="menu.idMenu" :menu="menu"></menu2>
          </template>
        </b-navbar-nav>
      </b-collapse>



        <b-navbar-nav class="ml-auto">
            <span class="logo-iniciales">{{ usrName | formatoIniciales}}</span>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right id="menu-usuario" class="item-nav-n2">
          <!-- Using 'button-content' slot -->

          <template #button-content>
            <table>
              <td>
                <span>{{ usrName }}</span>
                <br/>
                <template v-if="clinicas !== undefined && clinicas !== null && clinicas.length > 1">
                  <v-select :clearable="false" :options="clinicas"
                            v-model="clinicaActual" :reduce="(variable) => variable.idClinica" label="nombreClinica"
                            @click.native.stop.prevent class="opcion-menu" @input="refrescar()">
                    <span slot="no-options">No hay valores disponibles</span>
                  </v-select>
                </template>
                <em v-else>== {{ nombreClinica }} ==</em>
              </td>
            </table>
          </template>
          <b-dropdown-item class="" v-on:click="exit()">
            <font-awesome-icon icon="sign-out-alt"/>
            Cerrar sesión
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

    </b-navbar>
</template>

<script>
import Menu2 from "@/components/navbar/navbarV2/menu2";
export default {
  name: "nav2",
  components: { Menu2},
  props: {
    msg: String,
  },

  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    menuSeleccionado: {
      subMenus: []
    },
    usrName: null,
    nombreClinica: null,
    menuArray: [],
    activeRoutes: [],
    clinicas: [],
    clinicaActual: null,
    visibleM: null,
    localMenu: null
  }),
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push("/");
    }
  },
  beforeMount() {
    this.getMenu();
    this.usrName = this.$localStorageService.getNombreCompletoUsuario();
    this.nombreClinica = this.$localStorageService.getNombreClinica();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.clinicaActual = this.$localStorageService.getIdClinica();
    //this.clinicas = this.$localStorageService.getClinicas();///venir atacar aca
    this.getClinicasHeaders()
    this.localMenu = localStorage.munuPadre

  },
  watch: {
    clinicaActual() {
      this.$localStorageService.setClinicaActual(this.clinicaActual);
    },
    visble() {
      this.visibleM = localStorage.visible
    }
  },
  methods: {
    inicio() {
      localStorage.munuPadre = 0
      localStorage.menuHijo = 0
      this.$router.push({name: 'dashboard'});

    },
    seleccionar(menu) {
      if(menu != undefined && menu != null) {
        if (menu.subMenus.length>0){
          this.menuSeleccionado = Object.assign({}, menu)
          this.visibleM = true
          this.localMenu = menu.idMenu
        }else{
          localStorage.munuPadre = menu.idMenu
          this.menuSeleccionado = {
            subMenus: []
          }
          this.$router.push({name :menu.url});
        }

      }
    },
    getClinicasHeaders() {
      const parametros = {idUsuario: this.$localStorageService.getIdUsuario()}
      this.$http
          .post(
              this.$api +
              "catalogos/listaClinicasHeaders", parametros
          )
          .then(response => {
            if (Array.isArray(response.data.data) == true) {
              this.clinicas = response.data.data;
              this.clinicas.sort(function (a, b) {
                if (a.nombreClinica > b.nombreClinica) {
                  return 1;
                }
                if (a.nombreClinica < b.nombreClinica) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });
              let verificarExiteClicnica = this.$localStorageService.getIdClinica();
              let existeClinica = null;
              existeClinica = this.clinicas.find(cli => cli.idClinica === verificarExiteClicnica)
              if (existeClinica != null) {
                this.clinicaActual = this.$localStorageService.getIdClinica();
              } else {
                this.clinicaActual = this.clinicas[0].idClinica;
                this.$localStorageService.setClinicaActual(this.clinicaActual);
              }


            }
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al obtener el clinicas",
            });
            console.error(error);
          });

    },
    exit() {
      this.loading = true;
      this.$session.destroy();
      this.$router.push({
        name: "login"
      });
      this.$localStorageService.removeMenus();
      this.$localStorageService.removePostales();
    },
    myFunction(number) {
      document.getElementById(number).classList.toggle("show");
      this.menuArray.forEach(function (value) {
        if (value.idMenu == number) {
          value.active = value.active == false ? true : false;
        }
      });
    },
    ShowMenu(subMenus, id) {
      this.activeRoutes = subMenus;
      this.menuArray.forEach(function (value) {
        value.active = false;
        if (value.idMenu == id) {
          value.active = value.active == false ? true : false;
        }
      });
    },
    getMenu() {
      if (this.$localStorageService.existMenus()) {
        this.menuArray = this.$localStorageService.getMenus();

      } else {
        const parametros = {idUsuario: this.$localStorageService.getIdUsuario()}
        this.$http
            .post(
                this.$api +
                "menu/obtenerMenuUsuario", parametros
            )
            .then(response => {
              if (Array.isArray(response.data.data) == true) {
                response.data.data.forEach(element => {
                  if (element.subMenus.length != 0) {
                    element.active = false;
                    element.subMenus.forEach((elementSub) => {
                      elementSub.active = false;
                    });
                  }
                });

                this.menuArray = response.data.data; // !HARDCODEO menuArray
                this.$localStorageService.setMenus(this.menuArray);
                // var banderaMenu = false;
                // this.menuArray.forEach(element => {
                //     if(Array.isArray(element.subMenus)){
                //         element.subMenus.forEach(elementSubmenu => {
                //             banderaMenu = elementSubmenu.url == this.$router.currentRoute.name ? true : false
                //         });
                //     }
                //     banderaMenu = element.url == this.$router.currentRoute.name ? true : false
                // });

                // if(this.$router.currentRoute.name != 'dashboard'){// ! PANTALLAS UNIVERSALES
                //     if(banderaMenu == false){
                //         this.$router.push("dashboard");
                //     }
                // }
              }
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: "Error al obtener el menu",
              });
              console.error(error);
            });
      }

      // if (this.menuArray) {
      //   if (localStorage.munuPadre) {
      //     const index = this.menuArray.map(m => m.idMenu).indexOf(parseInt(localStorage.munuPadre));
      //     this.seleccionar(this.menuArray[index])
      //   } else {
      //     this.seleccionar(this.menuArray[0])
      //   }
      //
      // }
    },
    getSvg(url) {
      try {
        return require('../../../assets/menu/' + url + '.svg')
      } catch (error) {
        return require('../../../assets/menu/0.svg')
      }
    },
    refrescar() {
      this.$router.go();
    },
    activo(item) {
      if (parseInt(this.localMenu) === parseInt(item.idMenu)) {
        return true;
      }
      return false
    },
    actualizarVisible() {
      localStorage.visible = false
    }
  },
};
</script>
<style scoped>
.single-line {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inherit;
}
</style>
